module.exports = __webpack_public_path__ + "static/media/dennis.62f7a470.jpg";